<script>
import HeaderCheckbox from "../../content/common/PrimeVue/HeaderCheckbox.vue";
import SwitchOffTimesTimepicker from "./switch-off-times-timepicker.vue";
import {timeColonDelimitedToSeconds} from "../../../../utils/time";
import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue';

export default {
    name: "switch-off-times",
    components: { VTooltipWrapper, SwitchOffTimesTimepicker, HeaderCheckbox},
    props: {
        data: {},
        enableConfiguredByProject: Boolean,
        popupUsedInModal: Boolean,
    },
    computed: {
        translations() {
            return {
                title: Lang.langGet('Switch-On Times'),
                select: Lang.langGet('Select'),
                day: Lang.langGet('Day'),
                startTime: Lang.langGet('Start time'),
                endTime: Lang.langGet('End time'),
                everyDay: Lang.langGet('Same time for every day'),
                success: Lang.langGet("Successfully updated & transmitted Switch-On Times."),
                failed: Lang.langGet("Failed to update & transmit Switch-On Times."),
                updateButton: Lang.langGet('Update & Transmit To Clients'),
                configureByProject: Lang.langGet('The display is configured according to the project settings for each day.')
            }
        },
        tMessageOvernightMap() {
            const messagesMap = {};

            Object.keys(this.data.days).forEach(dayName => {
                if ((this.enableConfiguredByProject && this.data.all.project) || this.data.all.active || !this.data.days[dayName].active) {
                    messagesMap[dayName] = null;
                    return;
                }

                const toSeconds = timeColonDelimitedToSeconds(`${this.data.days[dayName].to.hh}:${this.data.days[dayName].to.mm}`);

                if(toSeconds == 0) return null;

                const fromSeconds = timeColonDelimitedToSeconds(`${this.data.days[dayName].from.hh}:${this.data.days[dayName].from.mm}`);

                messagesMap[dayName] = fromSeconds >= toSeconds ? this.translateContentPlaysOvernight(
                    `${this.data.days[dayName].from.hh}:${this.data.days[dayName].from.mm}`,
                    `${this.data.days[dayName].to.hh}:${this.data.days[dayName].to.mm}`) : null;

            });

            return messagesMap;
        },
        tMessageOvernightEveryday() {
            if ((this.enableConfiguredByProject && this.data.all.project) || !this.data.all.active) {
                return null;
            }
            const toSeconds = timeColonDelimitedToSeconds(`${this.data.all.to.hh}:${this.data.all.to.mm}`);

            if(toSeconds == 0) return null;

            const fromSeconds = timeColonDelimitedToSeconds(`${this.data.all.from.hh}:${this.data.all.from.mm}`);

            return fromSeconds >= toSeconds ? this.translateContentPlaysOvernight(
                `${this.data.all.from.hh}:${this.data.all.from.mm}`,
                `${this.data.all.to.hh}:${this.data.all.to.mm}`) : null;
        }
    },
    methods: {
        translateContentPlaysOvernight(start, end) {
            return Lang.langGet('Content plays from :start to 00:00 on this day and from 00:00 to :end the following day', { start, end });
        },
        translateDay(day) {
            return Lang.langGet(_.capitalize(day));
        },
        isSwitchedOff(day) {
            return this.data.days[day]?.active;
        },
        getDaysArray() {
            return Object.keys(this.data.days);
        },
        handleConfiguredByProjectChange(value) {
            const newData = _.cloneDeep(this.data);
            newData.all.project = value;

            this.$emit('input', newData);
        },
        handleActiveChange(day, value) {
            if (this.data.days[day]) {
                const newData = _.cloneDeep(this.data);

                newData.days[day].active = !value;
                this.$emit('input', newData);
            }
        },
        handleEveryDayChange(value) {
            const newData = _.cloneDeep(this.data);
            newData.all.active = value;

            this.$emit('input', newData);
        },
        handleDateChange(day, start, time) {
            const [hh,mm] = time?.includes(':') ? time.split(':') : ['00', '00'];
            const newData = _.cloneDeep(this.data);

            if (day === 'everyDay' && start) {
                newData.all.from.hh = hh;
                newData.all.from.mm = mm;
            }
            else if (day === 'everyDay' && !start) {
                newData.all.to.hh = hh;
                newData.all.to.mm = mm;
            }
            else if (start) {
                newData.days[day].from.hh = hh;
                newData.days[day].from.mm = mm;
            } else {
                newData.days[day].to.hh = hh;
                newData.days[day].to.mm = mm;
            }

            this.$emit('input', newData);
        }
    },
}
</script>

<template>
    <div class="switch-off-times">
        <div class="sot-grid mb-4">
            <div v-if="enableConfiguredByProject" class="sot-cell" style="grid-column: 1">
                <HeaderCheckbox
                    class="w-100 d-flex justify-center"
                    :selectMessage="translations.select"
                    :checked="data.all.project"
                    small
                    @change="({checked}) => handleConfiguredByProjectChange(checked)"
                />
            </div>
            <div v-if="enableConfiguredByProject" class="sot-cell-start" style="grid-column-start: 2; grid-column-end: 5">
                {{translations.configureByProject}}
            </div>
        </div>

        <div class="sot-grid mb-4">
            <div class="sot-cell">
                <HeaderCheckbox
                    :disabled="data.all.project"
                    :selectMessage="translations.select"
                    :checked="data.all.active"
                    small
                    @change="({checked}) => handleEveryDayChange(checked)"
                />
            </div>
            <div class="sot-cell-start">
                {{translations.everyDay}}
            </div>
            <div class="sot-cell">
                <switch-off-times-timepicker
                    id="sot-everyday-start"
                    :disabled="!data.all.active || data.all.project"
                    :value="`${data.all.from.hh}:${data.all.from.mm}`"
                    :popup-used-in-modal="popupUsedInModal"
                    @input="handleDateChange('everyDay', true, $event)"
                />
            </div>
            <div class="sot-cell">
                <switch-off-times-timepicker
                    id="sot-everyday-end"
                    :disabled="!data.all.active || data.all.project"
                    :value="`${data.all.to.hh}:${data.all.to.mm}`"
                    :popup-used-in-modal="popupUsedInModal"
                    @input="handleDateChange('everyDay', false, $event)"
                />
            </div>
            <div class="sot-cell">
                <v-tooltip-wrapper
                    v-if="tMessageOvernightEveryday"
                    :max-width="380"
                    content-class="tooltip-glass tooltip-white elevation-8 tooltip-border-colored tooltip-border-warning">
                    <template #activator="{ on, attrs }">
                        <v-icon color="warning"
                                style="cursor: help"
                                v-bind="attrs"
                                v-on="on">
                            far fa-triangle-exclamation
                        </v-icon>
                    </template>
                    {{ tMessageOvernightEveryday }}
                </v-tooltip-wrapper>
            </div>
        </div>

        <hr class="mt-0"/>

        <div class="sot-grid">
            <strong class="sot-cell"/>
            <strong class="sot-cell-start">{{translations.day}}</strong>
            <strong class="sot-cell">{{translations.startTime}}</strong>
            <strong class="sot-cell">{{translations.endTime}}</strong>

            <div class="sot-cell">
                <!-- This one is just to keep structure of grid, a "header" for the warning icons column -->
            </div>
            <template v-for="day in getDaysArray()">
                <div class="sot-cell">
                    <HeaderCheckbox
                        :disabled="data.all.active || data.all.project"
                        :selectMessage="translations.select"
                        :checked="isSwitchedOff(day)"
                        small
                        @change="({checked}) => handleActiveChange(day, !checked)"
                    />
                </div>
                <div class="sot-cell-start">
                    {{ translateDay(day) }}
                </div>
                <div class="sot-cell">
                    <switch-off-times-timepicker
                        :id="`sot-${day}-start`"
                        :disabled="data.all.active || !data.days[day]?.active || data.all.project"
                        :value="`${data.days[day].from.hh}:${data.days[day].from.mm}`"
                        :popup-used-in-modal="popupUsedInModal"
                        @input="handleDateChange(day, true, $event)"
                    />
                </div>
                <div class="sot-cell">
                    <switch-off-times-timepicker
                        :id="`sot-${day}-end`"
                        :disabled="data.all.active || !data.days[day]?.active || data.all.project"
                        :value="`${data.days[day].to.hh}:${data.days[day].to.mm}`"
                        :popup-used-in-modal="popupUsedInModal"
                        @input="handleDateChange(day, false, $event)"
                    />
                </div>
                <div class="sot-cell">
                    <v-tooltip-wrapper
                        v-if="tMessageOvernightMap[day]"
                        :max-width="380"
                        content-class="tooltip-glass tooltip-white elevation-8 tooltip-border-colored tooltip-border-warning">
                        <template #activator="{ on, attrs }">
                            <v-icon color="warning"
                                    style="cursor: help"
                                    v-bind="attrs"
                                    v-on="on">
                                far fa-triangle-exclamation
                            </v-icon>
                        </template>
                        {{ tMessageOvernightMap[day] }}
                    </v-tooltip-wrapper>
                </div>
            </template>
        </div>
    </div>
</template>

<style scoped>
    .sot-grid {
        display: grid;
        /* 32px for last column, for 24px icon and 4px padding on each side */
        grid-template-columns: 48px 2.5fr 2fr 2fr 32px;
    }
    .sot-cell-start {
        align-self: center;
    }
    .sot-cell {
        text-align: center;
        align-self: center;
        padding: 4px;
    }
</style>
